import {
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack,
} from "@chakra-ui/react";

const PreviewDialog = ({
  isOpen,
  onClose,
  title,
  children,
  isLoading,
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  isLoading: boolean;
}) => {
  return (
    <Modal isOpen={isOpen} isCentered onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        maxWidth="80vw"
        minHeight="80vh"
        mb={[0, "auto"]}
        borderBottomLeftRadius={[0, "md"]}
        borderBottomRightRadius={[0, "md"]}
      >
        <ModalHeader paddingTop={4}>
          <VStack gap={0} width={"full"}>
            <Text w="full">{title}</Text>
          </VStack>
        </ModalHeader>
        <ModalBody
          alignItems={"center"}
          justifyContent={"center"}
          flexWrap={"wrap"}
          overflowY={"scroll"}
        >
          {children}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default PreviewDialog;
